export type AppState = Record<string, any>;

export abstract class OAuthService {
  abstract login(state?: {[key: string]: any}): Promise<void>;
  abstract handleRedirect(): Promise<AppState>;
  abstract getAccessToken(): Promise<string>;
  abstract logout(): Promise<void>;
  abstract isAuthenticated(): Promise<boolean>;
}
